<template>
  <layout-component>
    <div class="banner banner-contact">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div v-if="$i18n.locale == 'en'">
              <h1 class="left-bullet">Cookie Policy</h1>
            </div>

            <div v-else>
              <h1 class="left-bullet">Politique relative aux cookies</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-policy">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-8">
            <div v-if="$i18n.locale == 'en'">
            <p>Sonotron uses cookies and other similar tools when users are navigating on Sonotron’s website (the “Website”).</p>
            <p>A cookie is a text-only string of information that a website transfers to the cookie file of the browser on your computer's hard disk so that the website can remember certain information about you. This can include which pages you have visited, choices you have made from menus, any specific information you have entered into forms and the time and date of your visit. Cookies cannot be used by themselves to identify you.</p>
            <p>Certain cookies are essential to be able to benefit from the full functionalities of the Website and its services. If a user completely blocks the use of the cookies, it is possible that part or all of the functionalities are no longer available. Other cookies may only be used to facilitate the navigation on the Website and are not essential. The user may refuse the use of the cookies by setting the browser functionalities to refuse certain types of cookies.</p>
            <p>Two types of cookies are used on this Website.</p>
            <ol>
              <li><strong>Session cookies</strong> are temporary cookies that remain in the cookie file of your browser until you leave the site.<br /> We use session cookies to carry information across pages of our site and avoid you having to re-enter information each time you enter a new page. </li>
              <li><strong>Persistent cookies</strong> remain in the cookie file of your browser even after the browser is closed. The length of time a cookie remains depends on its lifespan. We use persistent cookies to:
                <ul>
                  <li>help us recognize you as a unique user (just a number) when you return to our Website,</li>
                  <li>remember what kind of user you are and which parts of the information available to you, you have shown an interest in,</li>
                  <li>collect and compile anonymous, aggregated information for statistical and evaluation purposes to help us understand how users use the Website and help us improve the structure of our Website.</li>
                </ul>
              </li>
            </ol>
            <p>We inform you that we use third-party cookies for analyzing the statistics of the traffic on this Website in order to improve your navigation experience. These cookies are provided by Google Analytics; a web traffic analytic platform provided by Google, Sonotron opted for the anonymization of the IP address of the visitors to the Website. Therefore, these cookies do not collect identification information relating to you but allows Sonotron to use your anonymous connection data for statistical purposes related to the pages visited, the duration of the visits, the number of visitors etc.</p>
            <p>More information about Google Analytics and opt-out options is available at:<br/> <a href="https://support.google.com/analytics/answer/6004245" target="_blank">https://support.google.com/analytics/answer/6004245</a></p>

            <p>We use the following type of cookies:</p>
            <table>
              <tr>
                <th>Name of Cookie</th>
                <th>Type of Cookies</th>
                <th>Type of Cookies</th>
              </tr>
              <tr>
                <td>Google analytics</td>
                <td>Session cookies/persistent cookies</td>
                <td>Collect and compile anonymous, aggregated information for statistical and evaluation purposes to help us understand how users use the Website and help us improve the structure of our Website</td>
              </tr>
              <tr>
                <td>_ga / Duration: 2 years</td>
                <td>Perfomance</td>
                <td>Used to distinguish users.</td>
              </tr>
              <tr>
                <td>_gat / Duration : 1 minute</td>
                <td>Perfomance</td>
                <td>Used to throttle request rate.</td>
              </tr>
              <tr>
                <td>_gid /Duration: 24 hours</td>
                <td>Perfomance</td>
                <td>Used to distinguish users.</td>
              </tr>
              <tr>
                <td>Cookie agreed / Duration: 100 days</td>
                <td>Functional</td>
                <td>This cookie memorizes the user's choice to prevent redisplaying the banner he already accepted.</td>
              </tr>
            </table>
            <p>Sonotron or you may authorize third parties to install and use cookies to collect information about you when you navigate our Website.</p>
            <p>We do not control how these cookies are installed, how they are used and how they use the information collected. You should refer to the terms and conditions and privacy policy of the third parties concerned.</p>
            <p>No personal information (other than the IP address) is stored in our cookies.</p>
            <p>Most browsers are initially set to accept cookies. However, you have the ability to disable or suppress cookies if you wish, generally through changing the internet software browsing settings. It may also be possible to change the settings to enable acceptance of, refuse or suppress certain specific cookies. Please refer to the help section on your browser. If cookies are disabled it may mean that not all services of the Website, or indeed any, might be available.</p>
            <p>For more information about cookies and how to disable them please visit <a href="http://www.allaboutcookies.org" target="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a></p>

          </div>











          <div v-else>
            <p>Le Sonotron utilise des cookies et d’autres outils similaires lorsque ses utilisateurs naviguent sur le site Internet (ci-après dénommé le « site Internet »).</p>
            <p>Un cookie est une chaîne d’informations au format texte qu’un site Internet transfère vers le fichier des cookies du navigateur, sur le disque dur de votre ordinateur, afin de mémoriser certains renseignements vous concernant. Il peut s’agir des pages que vous avez consultées, des options que vous avez sélectionnées dans les menus, de toute information particulière que vous avez saisie dans les formulaires ainsi que de la date et de l’heure de votre visite. Les cookies ne peuvent pas à eux seuls permettre de vous identifier.</p>
            <p>Certains cookies s’avèrent essentiels pour bénéficier de toutes les fonctionnalités du site Internet et de ses services. Si un utilisateur bloque complètement les cookies, il est possible que tout ou partie des fonctionnalités deviennent indisponibles. D’autres cookies servent uniquement à faciliter la navigation sur le site Internet et ne s’avèrent pas essentiels. L’utilisateur peut refuser certains types de cookie en configurant les fonctionnalités de son navigateur en ce sens.</p>
            <p>Le site Internet utilise deux types de cookie.</p>
            <ol>
              <li><strong>Les cookies de session</strong> sont temporaires. Ils restent dans le fichier des cookies de votre navigateur jusqu’à ce que vous quittiez le site. <br />Ils nous permettent de transférer des informations d’une page vers l’autre pour vous éviter d’avoir à les saisir de nouveau à chaque fois que vous changez de page.</li>
              <li><strong>Les cookies persistants</strong> restent dans le fichier des cookies même après la fermeture de votre navigateur. Un cookie reste installé tout au long de sa durée de vie, qui est variable. Nous utilisons des cookies persistants pour :
                <ul>
                  <li>mieux vous reconnaître comme utilisateur unique (simple numéro) lorsque vous revenez sur notre site Internet ;</li>
                  <li>mémoriser le type d’utilisateur que vous êtes et les informations disponibles auxquelles vous avez porté intérêt ;</li>
                  <li>collecter et compiler des informations anonymes et agrégées aux fins d’analyse statistique et d’évaluation pour nous aider à comprendre l’usage que les utilisateurs font du site Internet et à améliorer la structure de ce dernier.</li>
                </ul>
              </li>
            </ol>
            <p>Nous vous informons que nous utilisons des cookies tiers pour analyser les statistiques du trafic sur le site Internet afin d’améliorer votre expérience de navigation. Ces cookies sont fournis par Google Analytics (plateforme d’analyse du trafic web de Google). Le Sonotron a opté pour l’anonymisation des adresses IP des visiteurs du site Internet. Par conséquent, ces cookies ne collectent aucune information permettant de vous identifier. En revanche, ils permettent au Sonotron d’utiliser vos données de connexion anonymes à des fins statistiques liées aux pages consultées, à la durée des visites, au nombre de visiteurs, etc.</p>
            <p>Pour obtenir plus d’informations sur Google Analytics et les options de refus, rendez-vous à l’adresse suivante :<br/> <a href="https://support.google.com/analytics/answer/6004245" target="_blank">https://support.google.com/analytics/answer/6004245</a></p>

            <p>Nous utilisons les cookies suivants :</p>
            <table>
              <tr>
                <th>Nom du cookie</th>
                <th>Type du cookie</th>
                <th>Fonction du cookie</th>
              </tr>
              <tr>
                <td>Google Analytics</td>
                <td>Cookies de session/persistants</td>
                <td>Collecter et compiler des informations anonymes et agrégées aux fins d’analyse statistique et d’évaluation pour nous aider à comprendre l’usage que les utilisateurs font du site Internet et à améliorer la structure de ce dernier</td>
              </tr>
              <tr>
                <td>_ga / Durée : 2 ans</td>
                <td>Perfomance</td>
                <td>Distinguer les utilisateurs</td>
              </tr>
              <tr>
                <td>_gat / Durée : 1 minute</td>
                <td>Perfomance</td>
                <td>Réguler le taux de requête</td>
              </tr>
              <tr>
                <td>_gid / Durée : 24 heures</td>
                <td>Perfomance</td>
                <td>Distinguer les utilisateurs</td>
              </tr>
              <tr>
                <td>Cookie accepté / Durée : 100 jours</td>
                <td>Fonctionnalités</td>
                <td>Mémoriser le choix de l’utilisateur afin d’éviter d’afficher de nouveau la bannière qu’il a déjà acceptée</td>
              </tr>
            </table>
            <p>Le Sonotron ou vous pouvez autoriser des tiers à installer et utiliser des cookies afin de collecter des informations vous concernant lorsque vous naviguez sur le site Internet.</p>
            <p>Nous ne contrôlons pas la façon dont lesdits cookies sont installés et utilisés ni l’usage qui est fait des informations collectées. Veuillez vous référer aux conditions générales et à la politique de confidentialité des tiers concernés.</p>
            <p>Nos cookies ne stockent aucune donnée à caractère personnel (autre que votre adresse IP).</p>
            <p>Dans leur configuration initiale, la plupart des navigateurs acceptent les cookies. Toutefois, vous pouvez en désactiver ou en supprimer si vous le souhaitez. En général, il vous suffit de modifier vos paramètres de navigation sur Internet. Il peut également être possible de modifier les paramètres afin d’accepter, de refuser ou de supprimer certains types de cookie. Veuillez vous référer à la rubrique d’aide de votre navigateur. La désactivation de cookies peut bloquer l’accès à certains, voire à l’intégralité des services du site Internet.</p>
            <p>Pour obtenir plus d’informations sur les cookies et leur désactivation, rendez-vous sur <a href="http://www.allaboutcookies.org" target="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a></p>
          </div>
          </div>
        </div>
      </div>
    </div>



	</layout-component>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>
